import React from 'react';
const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';
export const usePrefersReducedMotion = () => {
    const [prefersReducedMotion, setPrefersReducedMotion] = React.useState(() => window.matchMedia(REDUCED_MOTION_QUERY).matches);
    React.useEffect(() => {
        const mediaQueryList = window.matchMedia(REDUCED_MOTION_QUERY);
        const listener = (event) => setPrefersReducedMotion(event.matches);
        mediaQueryList.addEventListener('change', listener);
        setPrefersReducedMotion(mediaQueryList.matches);
        return () => mediaQueryList.removeEventListener('change', listener);
    }, []);
    return prefersReducedMotion;
};
export default usePrefersReducedMotion;
